export default __webpack_public_path__ + "static/media/poltrona-executivo.28891dc3.svg";